import styled from "styled-components";

export const Container = styled.main`
  min-width: 1440px;
  height: 4985px;
`;

export const Header = styled.h1`
  font-size: 67.34px;
  font-weight: 700;
  text-align: center;
  color: #151515;
  height: 80px;

  @media (max-width: 712px) {
    font-size: 32px;
    height: 22px;
  }

  @media (max-width: 600px) {
    font-size: 32px;
    height: 22px;
  }
`;

export const P = styled.p`
  display: flex;
  justify-self: center;
  font-size: 16px;
  font-weight: 400;
  text-align: center;
  color: #5d5d5d;
  width: 686px;
  height: 76px;
  margin: 0 auto 36px auto;
  /* margin-top: 16px; */
  /* margin-bottom: 36px; */

  @media (max-width: 712px) {
    font-size: 16px;
    line-height: 16.63px;
    width: 358px;
    margin: 24px auto 56px auto;
  }

  @media (max-width: 600px) {
    font-size: 14px;
    line-height: 16.63px;
    width: 358px;
    height: 68px;
    margin: 24px auto 56px auto;
  }

  @media (max-width: 362px) {
    width: 348px;
  }
`;

export const H3 = styled.h3`
  font-size: 28.43px;
  font-weight: 700;
  text-align: center;
  color: #191717;
  height: 35px;
  margin-bottom: 23px;
`;

export const StoreDiv = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  margin: 0 auto;
  width: 366px;
  height: 49px;

  @media (max-width: 362px) {
    width: 266px;
    justify-content: center;
    gap: 8px;
  }
`;

export const StoreLink = styled.a`
  transition: transform 0.3s ease, opacity 0.3s ease;

  &:hover {
    transform: scale(1.1);
    opacity: 0.8;
  }

  img {
    transition: opacity 0.3s ease;
  }

  &:hover img {
    opacity: 0.8;
  }
`;
export const Img = styled.img`
  width: 175px;
  height: 49px;
  border-radius: 5.6px;
`;

export const SecondSection = styled.section`
  display: flex;
  gap: 32px;
  justify-content: center;
  align-items: center;
  height: 328px;
  /* margin-top: 168px; */
  border-radius: 32px;
  background: #eefdfd;

  @media (max-width: 1280px) {
    /* width: 100%; */
  }

  @media (max-width: 1024px) {
    gap: 2px;
  }

  @media (max-width: 960px) {
      gap: 12px;
  }

  @media (max-width: 744px) {
    
  }

  @media (max-width: 600px) {
    display: block;
    position: relative;
    height: 680px;
  }

  /* @media (max-width: 395px) {
    width: 389px;

    } */

  /* @media (max-width: 440px) {
        width: 389px;
        margin: 0 auto;
    } */
`;

export const ImageDiv = styled.div`
  position: relative;
  width: 100%;

  @media (max-width: 1024px) {
    width: 65%;
  }

  @media (max-width: 960px) {
    width: 45%;
  }

  @media (max-width: 600px) {
    top: 21%;
    left: -5%;
    width: 100%;

  }

  @media (max-width: 440px) {
    top: 31%;
    left: -5%;
  }
`;


export const VipImage = styled.img`
 @media (max-width: 960px) {
    width: 389px;
    height: 489px;
  }

  @media (max-width: 600px) {
    /* position: relative; */
    width: 389px;
    height: 489px;
    /* margin-left: 45px; */
    /* left: 5; */
  }

  @media (max-width: 440px) {
    position: absolute;
    /* width: 100%; */
    right: -3%;
    /* top: -55%; */
    margin-top: -75px;
  }
`;

export const VipPopImg = styled.img`
  position: absolute;
  bottom: 75%;
  left: 71%;

  @media (max-width: 960px) {
    width: 76px;
    height: 67.88px;
    bottom: 81%;
    left: 85%;
  }

  @media (max-width: 820px) {
    left: 95%;
  }

  @media (max-width: 600px) {
    width: 76px;
    height: 67.88px;
    bottom: 85%;
    left: 63%;
  }

  @media (max-width: 440px) {
    left: 70%;
  }
`;

export const H4 = styled.h4`
    font-size: 48px;
    font-weight: 700;
    line-height: 34.12px;
    width: 90%;
    height: 35px;
    

    @media (max-width: 1430px){
        line-height: 44px;
        height: 64px;
    }

    @media (max-width: 1200px) {
      font-size: 28px;
      line-height: 28px;
      height: 34px;
      /* width: 90%; */
    }

    @media (max-width: 1024px) {
      height: 14px;
    }

    @media (max-width: 1012px) {
      font-size: 28px;
    }

    @media (max-width: 960px) {
      height: 54px;
    }

    @media (max-width: 744px) {
      width: 193px;
      line-height: 22px;
      margin-bottom: 32px;
    }

    @media (max-width: 600px) {
      position: absolute;
      top: 5%;
      left: 5%;
      font-size: 28px;
      line-height: 28px;
    }

  @media (max-width: 440px) {
   width: 297px;
  }
`;

export const VipSubContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: last baseline;
  height: 100px;
  /* width: 525px; */
  width: 100%;
  margin-top: 8px;

  @media (max-width: 1024px) {
    width: 90%;
    height: 120px;
    margin-top: 16px;
  }

  @media (max-width: 1012px) {

  }

  @media (max-width: 960px) {
    width: 455px;
    height: 50px;
  }

  @media (max-width: 788px) {
    /* width: 80%; */
  }

  @media (max-width: 744px) {
    width: 355px;
  }

  @media (max-width: 440px) {
    width: 100%;
  }
`;

export const CheckIcon = styled.img`
  width: 36px;
  height: 36px;

  @media (max-width: 1200px) {
    width: 25.5px;
    height: 25.5px;
  }

  @media (max-width: 600px) {
    position: absolute;
    top: 14%;
    left: 5%;
    font-size: 28px;
    width: 25.5px;
    height: 25.5px;
  }
`;

export const VipText = styled.p`
  font-size: 21.33px;
  font-weight: 500;
  line-height: 25.6px;
  letter-spacing: -0.03em;
  width: 430px;
  /* width: 90%; */
  height: 52px;
  text-align: left;
  /* padding-top: 24px; */

  @media (max-width: 1200px) {
    width: 330px;
    font-size: 16px;
  }

  /* @media (max-width: 1012px) {
    width: 330px;
  } */

  @media (max-width: 1012px) {
    line-height: 18.23px;
    font-size: 14px;
    width: 293px;
  }

  @media (max-width: 744px) {
    width: 193px;
  }

  @media (max-width: 600px) {
    position: absolute;
    top: 15.4%;
    left: 5%;
    line-height: 18.23px;
    font-size: 14px;
    width: 293px;
  }
`;

export const ThirdSection = styled.section`
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
  height: 391px;
  margin-top: 115px;
  border-radius: 32px;
  background: #1a7384;

  @media (max-width: 960px) {
    height: 321px;
  }

  @media (max-width: 600px) {
    display: block;
    margin-top: 0;
    position: relative;
    top: -6.5%;
    height: 880px;
  }

  @media (max-width: 397px) {
       height: 900px;
    }
`;

export const RateH4 = styled.h4`
    font-size: 48px;
    font-weight: 700;
    width: 509px;
    /* width: 90%; */
    line-height: 56.12px;
    height: 82px;
    color: #ffff;

  /* @media (max-width: 1024px) {
    line-height: 44.12px;
    position: absolute;
    left: 10%;
  } */

  @media (max-width: 1200px) {
    /* position: absolute; */
    top: 30%;
    left: 5%;
    font-size: 28px;
    line-height: 30px;
    height: 42px;
    width: 434px;
  }

  @media (max-width: 600px){
      /* position: absolute; */
      padding-top: 23px;
      padding-left: 23px;
      font-size: 28px;
      line-height: 30px;
      width: 334px;
  }

  @media (max-width: 440px) {
    width: 313px;
    height: 40px;
  }
`;


export const RateSubContainer = styled.div`
    display: flex;
    /* margin-top: 52px; */
    /* gap: 16px; */
    align-items: left;
    justify-content: left;
    height: 104px;
    width: 684px;
    /* width: 50%; */
    /* position: relative; */

    @media (max-width: 1116px) {
      /* left: 5%; */
      margin-left: 5%;
    }

    @media (max-width: 1012px) {
      /* height: 50px; */
      /* margin-top: 44px; */
      /* width: 35%; */
      height: 82px;
      /* left: 10%; */
    }

    @media (max-width: 982px) {
      /* left: 5%; */
    }

    @media (max-width: 600px) {
        position: static;
        width: 384px;
        padding-top: 129px;
    }

    @media (max-width: 440px) {
      width: 100%;
    }
`;

export const RateCheckIcon = styled.img`
  width: 36px;
  height: 36px;


  @media (max-width: 1200px) {
    position: absolute;
    /* left: 5%; */
    font-size: 28px;
    width: 25.5px;
    height: 25.5px;
  }

  @media (max-width: 600px) {
    position: absolute;
    top: 17%;
    left: 5%;
    font-size: 28px;
    width: 25.5px;
    height: 25.5px;
  }

  @media (max-width: 440px) {
    top: 20%;
  }
`;

export const RateText = styled.p`
  /* position: absolute; */
  font-size: 21.33px;
  font-weight: 500;
  line-height: 25.6px;
  letter-spacing: -0.03em;
  /* width: 930px; */
  width: 60%;
  height: 52px;
  text-align: left;
  /* margin-top: 92px; */
  /* padding-top: 11px; */

 @media (max-width: 1200px) {
  font-size: 16px;
  /* left: 5%; */

 }

  @media (max-width: 1012px) {
    /* position: absolute; */
    top: 36%;
    /* left: 33.25%; */
    font-size: 16px;
    line-height: 18.23px;
    width: 293px;
  }

  @media (max-width: 600px) {
    position: absolute;
    top: 16%;
    left: 5%;
    font-size: 14px;
    line-height: 18.23px;
    width: 293px;
  }

  @media (max-width: 440px) {
    width: 291px;
    /* top: 19%; */
  }
`;

export const RatePopImg = styled.img`
  position: absolute;
  bottom: 80%;
  right: -20%;

  @media (max-width: 960px) {
    width: 76px;
    height: 67.88px;
    right: -5%;
  }

  @media (max-width: 764px) {
    width: 76px;
    height: 67.88px;
    right: -10%;
  }

  @media (max-width: 600px) {
    width: 76px;
    height: 67.88px;
    bottom: 85%;
    right: 5%;
  }

  @media (max-width: 376px) {
    bottom: 92%;
  }
`;

export const RateImageDiv = styled.div`
  position: relative;

  @media (max-width: 960px) {
    
  }

  @media (max-width: 600px) {
    top: 9%;
    /* left: 7%; */
    width: 344px;
    margin: 0 auto;
  }

  @media (max-width: 440px) {
    top: 9%;
  }
`;

export const RateImage = styled.img`
 @media (max-width: 960px) {
    width: 389px;
    height: 489px;
  }

  @media (max-width: 764px) {
    width: 289px;
  }

  @media (max-width: 600px) {
    width: 289px;
    height: 489px;
  }

  @media (max-width: 377px) {
    width: 100%;
  }
`;


export const FourthSection = styled.section`
  position: relative;
  display: flex;
  gap: 40px;
  justify-content: center;
  align-items: center;
  height: 328px;
  margin-top: 168px;
  border-radius: 32px;
  background: #eefdfd;

  @media (max-width: 1024px) {
    gap: 2px;
  }

  @media (max-width: 960px) {
    
  }

  @media (max-width: 600px) {
    display: block;
    margin-top: 0;
    position: relative;
    top: 0;
    height: 680px;
  }

  /* @media (max-width: 440px) {
        width: 389px;
        margin: 0 auto;
    } */
`;

export const OrderImageDiv = styled.div`
  position: relative;
  top: 59%;
  /* width: 100%; */

  @media (max-width: 1024px) {
    /* left: 15%; */
    /* width: 50% */
  }

  @media (max-width: 960px) {
    
  }

  @media (max-width: 600px) {
    top: 125px;
    left: -8%;
  }
`;

export const OrderImage = styled.img`
  @media (max-width: 960px) {
    position: relative;
    width: 389px;
    height: 489px;
    right: -3%;
  }

  @media (max-width: 600px) {
    position: relative;
    width: 389px;
    height: 489px;
    /* margin-left: 40px; */
    right: -4%;
    margin-top: 25px;
  }

  @media (max-width: 440px) {
    position: relative;
    right: -3%;
    margin-top: 25px;
  }

  @media (max-width: 377px) {
    width: 100%;
  }
`;

export const VipPop1 = styled.img`
  position: absolute;
  top: 39%;
  left: 22%;

  @media (max-width: 960px) {
    width: 238.79px;
    height: 45.76px;
  }

  @media (max-width: 600px) {
    width: 238.79px;
    height: 45.76px;
  }

  @media (max-width: 377px) {
    left: 20.5%;
  }
`;

export const VipPop2 = styled.img`
  position: absolute;
  top: 48.5%;
  left: 22%;

  @media (max-width: 960px) {
    width: 238.79px;
    height: 91.52px;
  }

  @media (max-width: 600px) {
    width: 238.79px;
    height: 91.52px;
  }

  @media (max-width: 377px) {
    left: 20.5%;
  }
`;
export const VipPop3 = styled.img`
  position: absolute;
  top: 68%;
  left: 22%;

  @media (max-width: 960px) {
    width: 238.79px;
    height: 115.65px;
  }

  @media (max-width: 600px) {
    width: 238.79px;
    height: 115.65px;
  }

  @media (max-width: 377px) {
    left: 20.5%;
  }
`;

export const OrderH4 = styled.h4`
  font-size: 48px;
  font-weight: 700;
  line-height: 56px;
  width: 509px;
  height: 112px;

  @media (max-width: 1200px) {
    font-size: 28px;
    width: 90%;
    height: 22px;
    line-height: 26px;
  }


  @media (max-width: 1024px) {
    line-height: 22.12px;
    width: 100%;
    height: 22px;
  }

  @media (max-width: 1012px) {
    font-size: 28px;
    /* line-height: 30px; */
    /* width: 341px; */
    /* width: 100%; */
    /* height: 52px; */
  }

  @media (max-width: 600px) {
    position: absolute;
    top: 5%;
    left: 5%;
    font-size: 28px;
    line-height: 30px;
    width: 341px;
  }

  @media (max-width: 440px) {
    /* width: 341px; */
    width: 80%;
  }
`;

export const OrderSubContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: last baseline;
  justify-items: center;
  width: 584px;
  height: 104px;
  margin-top: 8px;

  @media (max-width: 1200px) {
    width: 50%;
  }

  @media (max-width: 1177px) {
    width: 80%;
  }

  @media (max-width: 960px) {
    /* width: 85%; */
  }

  @media (max-width: 600px) {
    position: static;
    width: 384px;
  }

  @media (max-width: 393px) {
    width: 341px;
  }
`;

export const OrderPopImg = styled.img`
  position: absolute;
  bottom: 74%;
  left: 75%;

  @media (max-width: 960px) {
    width: 76px;
    height: 67.88px;
    left: 78%;
    bottom: 81%;
  }

  @media (max-width: 600px) {
    width: 76px;
    height: 67.88px;
    bottom: 84%;
    left: 65%;
  }
  @media (max-width: 440px) {
    left: 75%;
  }
`;

export const OrderCheckIcon = styled.img`
  width: 36px;
  height: 36px;

  @media (max-width: 1200px) {
    width: 25.5px;
    height: 25.5px;
  }

  @media (max-width: 600px) {
    position: absolute;
    top: 15%;
    left: 5%;
    font-size: 28px;
    width: 25.5px;
    height: 25.5px;
  }
  @media (max-width: 440px) {
    top: 15.5%;
  }
`;

export const OrderText = styled.p`
  font-size: 21.33px;
  font-weight: 500;
  line-height: 25.6px;
  letter-spacing: -0.03em;
  width: 430px;
  height: 52px;
  text-align: left;
  /* padding-top: 24px; */

  @media (max-width: 1200px) {
    line-height: 18.23px;
    font-size: 16px;
    width: 191px;
  }

  @media (max-width: 600px) {
    position: absolute;
    top: 15.4%;
    left: 5%;
    line-height: 18.23px;
    font-size: 14px;
    width: 191px;
  }

  @media (max-width: 440px) {
    max-width: 191px;
    top: 15%;
  }
`;

export const FifthSection = styled.section`
  display: flex;
  gap: 28px;
  justify-content: center;
  align-items: center;
  margin-top: 106px;
  margin-bottom: 100px;

  @media (max-width: 1280px) {
    /* width: 1200px; */
    /* gap: 5px; */
    /* align-items: none; */
  }


  @media (max-width: 1012px) {
    display: block;
  }

  @media (max-width: 600px) {
    display: block;
    margin-top: 76px;
    margin-bottom: 70px;
  }
`;

export const CardOne = styled.div`
    background: #EEFDFD;
    /* width: 586px; */
    width: 51%;
    height: 821px;
    padding: 53px 9px 23px 0;
    border-radius: 42px;
    /* position: relative; */

    @media (max-width: 1200px) {
    height: 720px;
    /* margin: 0 auto; */
    /* padding: 23px 9px 23px 0px; */
  }


  @media (max-width: 1024px) {
    width: 450px;
    height: 620px;
    margin: 0 auto;
    padding: 23px 9px 23px 0px;
  }

  @media (max-width: 960px) {
    width: 389px;
    height: 620px;
  }

  @media (max-width: 600px) {
    width: 389px;
    height: 680px;
  }

  @media (max-width: 440px) {
    /* width: 389px; */
    width: 95%;
  }

  @media (max-width: 412px) {
    width: 366px;
  }

  @media (max-width: 362px) {
    width: 352px;
  }
`;

export const CardTwo = styled.div`
    background: #1A7384;
    /* width: 586px; */
    width: 51%;
    height: 821px;
    padding: 53px 9px 23px 0px;
    border-radius: 42px;
    /* position: relative; */

    
    @media (max-width: 1200px) {
     height: 720px;
   
  }

  @media (max-width: 1024px) {
    width: 450px;
    margin: 0 auto;
    height: 620px;
    padding: 23px 9px 23px 0px;
  }

  @media (max-width: 1012px) {
    margin-top: 54px;
  }

  @media (max-width: 960px) {
    width: 389px;
    height: 620px;
  }

  @media (max-width: 900px) {
    margin-top: 56px;
  }


  @media (max-width: 600px) {
    width: 389px;
    height: 680px;
    margin-top: 56px;
  }

  @media (max-width: 440px) {
    /* width: 389px; */
    width: 95%;
  }

  @media (max-width: 412px) {
    width: 366px;
  }

  @media (max-width: 362px) {
    width: 352px;
  }
`;

export const PriceImageDiv = styled.div`
  position: relative;
`;

export const PriceH5 = styled.h5`
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  width: 577px;
  margin: 0 auto;
  color: #101828;

  @media (max-width: 1280px) {
    width: 450px;
  }

  @media (max-width: 1200px) {
    font-size: 24px;
    line-height: 26px;
  }

  @media (max-width: 1024px) {
    width: 350px;
  }

  @media (max-width: 1012px) {
    font-size: 24px;
    line-height: 26px;
  }

  @media (max-width: 600px) {
    font-size: 24px;
    line-height: 26px;
    margin-top: 16px;
    margin-bottom: 16px;
  }

  @media (max-width: 440px) {
    width: 276px;
  }
`;

export const SignInH5 = styled.h5`
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  width: 577px;
  margin: 0 auto;
  color: #ffff;


  @media (max-width: 1280px) {
    width: 450px;
  }

  @media (max-width: 1200px) {
    font-size: 24px;
    line-height: 26px;
  }


  @media (max-width: 1024px) {
    width: 350px;
  }

  @media (max-width: 1012px) {
    font-size: 24px;
    line-height: 26px;
  }

  @media (max-width: 600px) {
    font-size: 24px;
    line-height: 26px;
    margin-top: 16px;
    margin-bottom: 8px;
  }

  @media (max-width: 440px) {
    width: 303px;
  }
`;

export const SignInText = styled.p`
  font-size: 16px;
  font-weight: 500;
  text-align: center;

  @media (max-width: 1200px) {
    font-size: 16px;
  }

  @media (max-width: 960px) {
    font-size: 16px;
    /* width: 222px; */
  }

  @media (max-width: 600px) {
    font-size: 14px;
    margin-bottom: 16px;
  }

  @media (max-width: 440px) {
    /* width: 357px; */
  }
`;

export const CardOneImage = styled.img`
    @media (max-width: 1200px) {
        position: relative;
        right: 2%;
        width: 389px;
    }

    @media (max-width: 960px) {
      width: 389px;
      height: 489px;
      right: 8%;
  }

  @media (max-width: 600px) {
    right: 1%;
    width: 389px;
    height: 489px;
    /* margin-left: 12.5%; */
  }

  @media (max-width: 440px) {
    margin-left: 0;
    right: 1%;
    top: 95%;
    margin-top: 35px;
  }

  @media (max-width: 412px) {
    width: 100%;
  }
`;

export const CardTwoImage = styled.img`
 @media (max-width: 1200px) {
        position: relative;
        right: 2%;
        width: 389px;
    }

    @media (max-width: 1024px) {
        position: relative;
        /* right: 20%; */
        width: 389px;
    }

    @media (max-width: 960px) {
      width: 389px;
      height: 489px;
      right: 10%;
  }

  @media (max-width: 600px) {
    right: 2.5%;
    width: 389px;
    height: 489px;
    /* margin-left: 12.5%; */
  }

  @media (max-width: 440px) {
    margin-top: 45px;
    margin-left: 0;
    right: 2.5%;
  }

  @media (max-width: 412px) {
    width: 100%;
  }
`;

export const CardPop = styled.img`
  position: absolute;
  bottom: 80%;
  left: 70%;

  @media (max-width: 1200px) {
    width: 76px;
    height: 67.88px;
  }

  @media (max-width: 960px) {
    width: 76px;
    height: 67.88px;
  }

  @media (max-width: 600px) {
    width: 76px;
    height: 67.88px;
    left: 72%;
    bottom: 85%;
  }

  @media (max-width: 440px) {
    bottom: 85%;
  }
`;

export const WideText = styled.img`
    position: absolute;
    bottom: 9%;
    left: 3%;

  @media (max-width: 1200px) {
    width: 339px;
  }

  @media (max-width: 960px) {
    width: 312px;
    height: 93px;
  }

  @media (max-width: 600px) {
    left: 10.5%;
    width: 312px;
    height: 93px;
  }

  @media (max-width: 412px) {
    left: 5%;
  }
`;
export const CouponsImg1 = styled.img`
    position: absolute;
    bottom: 40%;
    left: 20.32%;

  @media (max-width: 1200px) {
    width: 264px;
    left: 11%;
    height: 127px;

  }

  @media (max-width: 1024px) {
    /* left: 7%; */
  }

  @media (max-width: 960px) {
    width: 264px;
    height: 127px;
  }

  @media (max-width: 600px) {
    left: 15.5%;
    width: 264px;
    height: 127px;
  }

  @media (max-width: 440px) {
    left: 14.1%;
  }

  @media (max-width: 377px) {
    left: 10%;
  }
`;

export const CouponsImg2 = styled.img`
    position: absolute;
    bottom: 23%;
    left: 20.32%;

  @media (max-width: 1200px) {
    width: 264px;
    height: 80px;
    left: 11%;

  }

  @media (max-width: 1024px) {
    /* left: 7%; */
  }


  @media (max-width: 960px) {
    width: 234px;
    height: 80px;
    left: 10.5%;
  }

  @media (max-width: 600px) {
    left: 18.1%;
    width: 234px;
    height: 80px;
  }

  @media (max-width: 377px) {
    left: 14%;
  }
`;

export const CouponsImg3 = styled.img`
    position: absolute;
    bottom: 9.5%;
    left: 20.32%;

  @media (max-width: 1200px) {
    width: 264px;
    height: 80px;
    left: 11%;
  }

  @media (max-width: 1024px) {
    /* left: 7%; */
  }

  @media (max-width: 960px) {
    width: 242px;
    height: 80px;
    left: 9.5%;
  }

  @media (max-width: 600px) {
    left: 17.4%;
    width: 242px;
    height: 80px;
  }

  @media (max-width: 377px) {
    left: 12.4%;
  }

`;

export const SixthSection = styled.section`
  display: flex;
  gap: 28px;
  justify-content: center;
  align-items: center;
  margin-top: 106px;
  margin-bottom: 100px;

  @media (max-width: 1012px) {
    display: block;
  }

  @media (max-width: 600px) {
    display: block;
  }
`;

export const CardThree = styled.div`
  background: #1a7384;
  /* width: 586px; */
  width: 51%;
  height: 821px;
  padding: 53px 9px 23px 0px;
  border-radius: 42px;
  position: relative;

  @media (max-width: 1200px) {
    height: 720px;
  }

  @media (max-width: 1024px) {
    width: 450px;
    height: 620px;
    margin: 0 auto;
    padding: 23px 9px 23px 0px;
  }

  @media (max-width: 960px) {
    width: 389px;
    height: 680px;
  }

  @media (max-width: 600px) {
    width: 389px;
    height: 680px;
    margin-top: 56px;
  }

  @media (max-width: 440px) {
    width: 389px;
    width: 95%;
  }

  @media (max-width: 412px) {
    width: 366px;
  }

  @media (max-width: 362px) {
    width: 352px;
  }
`;

export const UsdH5 = styled.h5`
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  width: 577px;
  margin: 0 auto;
  color: #fff;

  @media (max-width: 1280px) {
    width: 450px;
  }

  @media (max-width: 1200px) {
   font-size: 24px;
  }

  @media (max-width: 1012px) {
    width: 143px;
    font-size: 24px;
  }

  @media (max-width: 600px) {
    width: 143px;
    font-size: 24px;
    margin-top: 16px;
  }

  @media (max-width: 440px) {
    width: 143px;
  }
`;

export const CardThreeText = styled.p`
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  /* width: 577px; */

  @media (max-width: 1200px) {
    font-size: 16px;
  }

  @media (max-width: 1012px) {
    font-size: 16px;
    width: 257px;
    margin: 0 auto 16px auto; 
  }

  @media (max-width: 600px) {
    font-size: 14px;
    width: 257px;
    margin: 0 auto 16px auto; 
  }
`

export const UsdImg = styled.img`
  @media (max-width: 1200px) {
    width: 389px;
  }

  @media (max-width: 1024px) {
    position: relative;
    /* right: 20%; */
  }

  @media (max-width: 960px) {
    width: 389px;
    height: 489px;
    right: 10%;
  }

  @media (max-width: 600px) {
    margin-top: 5px;
    left: -1%;
    width: 389px;
    height: 489px;
    margin-top: 45px;
  }

  @media (max-width: 440px) {
    margin-top: 45px;
    left: -1%;
  }

  @media (max-width: 412px) {
    width: 100%;
  }
`;

export const UsdtCardPop = styled.img`
    position: absolute;
    bottom: 72%;
    left: 63%;

    @media (max-width: 1200px) {
      width: 76px;
      height: 67.88px;
      left: 70%;
      bottom: 75%;
    }

    @media (max-width: 960px) {
      width: 76px;
      height: 67.88px;
      left: 70%;
  }

  @media (max-width: 600px) {
    left: 65%;
    top: 17%;
    width: 76px;
    height: 67.88px;
  }

  @media (max-width: 440px) {
    top: 19%;
  }
`;

export const GroupPop = styled.img`
  position: absolute;
  bottom: 24%;
  left: 3%;

  @media (max-width: 1200px) {
    width: 334px;
    bottom: 34%;
  }

  @media (max-width: 1024px) {
    width: 334px;
    bottom: 24%;
    /* left: -1%; */
  }

  @media (max-width: 960px) {
    
  }

  @media (max-width: 600px) {
    left: 5%;
  }

  @media (max-width: 440px) {
    left: 5%;
  }

  @media (max-width: 393px) {
    left: 1%;
  }
`;

export const CardFour = styled.div`
  background: #eefdfd;
  /* width: 586px; */
  width: 51%;
  height: 821px;
  padding: 53px 9px 23px 0px;
  border-radius: 42px;
  position: relative;

  @media (max-width: 1200px) {
    height: 720px;
  }

  @media (max-width: 1024px) {
    width: 450px;
    height: 620px;
    margin: 0 auto;
    padding: 23px 9px 23px 0px;
  }

  @media (max-width: 1012px) {
    margin-top: 54px;
  }

  @media (max-width: 960px) {
    width: 389px;
    height: 680px;
  }

  @media (max-width: 900px) {
    margin-top: 56px;
  }

  @media (max-width: 600px) {
    width: 389px;
    height: 680px;
    margin-top: 56px;
  }

  @media (max-width: 440px) {
    /* width: 389px; */
    width: 95%;
  }

  @media (max-width: 412px) {
    width: 366px;
  }

  @media (max-width: 362px) {
    width: 352px;
  }
`;

export const CardFourH5 = styled.h5`
  font-size: 32px;
  font-weight: 700;
  line-height: 38px;
  text-align: center;
  width: 506px;
  height: 130px;
  margin: 0 auto;
  color: #101828;

  @media (max-width: 1200px) {
    font-size: 24px;
    line-height: 26px;;
    width: 357px;
  }


  @media (max-width: 1024px) {
    /* width: 420px; */
  }

  @media (max-width: 1012px) {
    font-size: 24px;
    line-height: 26px;
    width: 357px;
  }

  @media (max-width: 600px) {
    font-size: 24px;
    line-height: 26px;
    margin-top: 16px;
    width: 357px;
  }

  @media (max-width: 440px) {
    width: 357px;
  }

  @media (max-width: 412px) {
    width: 293px;
  }
`;

export const ShareImage = styled.img`
  position: relative;
  left: 6%;

  @media (max-width: 1200px) {
    width: 389px;
  }

  @media (max-width: 1024px) {
    /* position: relative; */
    /* right: 6.5%; */
    left: 5%;
    
  }

  @media (max-width: 960px) {
    width: 389px;
    height: 489px;
  }

  @media (max-width: 600px) {
    top: -45px;
    left: 1%;
    width: 389px;
    height: 489px;
  }

  @media (max-width: 440px) {
    /* right: 1%; */
  }

  @media (max-width: 412px) {
    width: 100%;
  }
`;
